module.exports = __webpack_public_path__ + "img/success.0b3169d9.svg";